import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import { InputOtpComponent } from '@component/input-otp/input-otp.component';
import { LoginRequest } from '@models/login/login-model.model copy';
import { LoginService } from '@services/login/login.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { UsuarioService } from '@services/usuario/usuario.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { AuthLayoutComponent } from '../auth-layout/auth-layout.component';


@Component({
  standalone: true,
   imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule,  A11yModule, CommonModule, MatExpansionModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDatepickerModule, MatRadioModule, MatSelectModule, FormsModule, MatSortModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, MatTabsModule, MatCheckboxModule, MatAutocompleteModule, MatChipsModule, MatTabsModule, DragDropModule, MatSidenavModule,MatListModule,InputOtpComponent,AuthLayoutComponent],
  selector: 'app-form-verificar-cuenta-usuario',
  templateUrl: './form-verificar-cuenta-usuario.component.html',
  styleUrls: ['./form-verificar-cuenta-usuario.component.css']
})
export class FormVerificarCuentaUsuarioComponent {

  form!: FormGroup;
  formBuilder: FormBuilder = new FormBuilder;
  idUsuario!: number;
  contraseña!: string;
  correo!: string;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private loginService: LoginService,
    private usuarioService: UsuarioService,
    private http: HttpClient,
    private route: ActivatedRoute
  ) {
    const phoneRegex = /^\+?\d{1,4}?[ -.]?\(?\d{1,4}\)?[ -.]?\d{1,9}([ -.]?\d{1,9})?$/;

    this.route.queryParams.subscribe(params => {
      this.correo = params['correo']
      this.idUsuario = params['idUsuario']
      this.contraseña = params['contraseña']

      this.form.controls["Correo"].setValue(this.correo)
      this.form.controls["IdUsuario"].setValue(this.idUsuario)
      this.form.controls["Contraseña"].setValue(this.contraseña)
    })


  }

  ngOnInit() {
  }

  onOtpComplete(otp: string) {
    this.form.controls["OTP"].setValue(otp)
    this.verifyCodeCorreo(this.idUsuario, otp)
  }

  verifyCodeCorreo(idUsuario: number, code: string) {
    this.spinner.show('spVerifyCodeCorreo')
    this.usuarioService.verifyCodeCorreo(idUsuario, code)
      .subscribe(
        data => {
          this.spinner.hide('spVerifyCodeCorreo')
          this.login;
        },
        error => {
          this.spinner.hide('spVerifyCodeCorreo')
          this.snackBar.showError(error, "Error");
        })
  }

  login() {
    const loginRequest = new LoginRequest
    loginRequest.userName = this.correo
    loginRequest.password = this.contraseña
    this.spinner.show('spVerifyCodeCorreo')
    this.loginService.login(loginRequest)
      .subscribe(
        data => {
          this.spinner.hide('spVerifyCodeCorreo')
          this.router.navigate(['/bienvenido']);
        },
        error => {
          this.spinner.hide('spVerifyCodeCorreo')
          this.snackBar.showError(error, "Error");
        })
  }


}
